import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import chevronLeft from '../../../assets/images/icons/chevron-left.svg';
import TopNav from "../../TopNav/TopNav";
import SideBar from "../../SideBar/SideBar";
import api from "../../../services/api";
import {toast} from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "../../../components/Buttons/Button";

function WithdrawalRequestDetails() {
    const { requestId } = useParams();
    const navigate = useNavigate();
    const [requestData, setRequestData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [adminRemark, setAdminRemark] = useState("");
    const [adminStatus, setAdminStatus] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const handleReviewSubmit = async () => {
        if (!adminStatus) {
            toast.error("Please select a status before submitting.");
            return;
        }

        setIsSubmitting(true);

        const reviewPayload = {
            status: adminStatus,
            remark: adminRemark,
        };

        try {
            const response = await api.post(`venue-owners/review-withdrawal-request/${requestData?._id}`, reviewPayload);

            console.log("Review submitted successfully:", response.data);
            toast.success("Review submitted successfully.");
            setShowSuccess(true);
        } catch (err) {
            console.error("Failed to submit review", err);
            toast.error("An error occurred while submitting your review. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        const fetchWithdrawalDetails = async () => {
            setLoading(true);
            try {
                const res = await api.get(`/venue-owners/fetch-withdrawal-request-details/${requestId}`);

                console.log(res.data.data);
                setRequestData(res.data.data);
                setLoading(false);
            } catch (error) {
                console.error('Failed to fetch withdrawal request details:', error);
            } finally {
                setLoading(false);
            }
        };

        console.log(requestId)

        if (requestId) {
            fetchWithdrawalDetails();
        }
    }, [requestId, navigate]);


    // Format date for display
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { month: "short", day: "2-digit", year: "numeric" };
        return date.toLocaleDateString("en-US", options);
    };

    const SuccessModal = () => (
        <Modal show={showSuccess} onHide={() => setShowSuccess(false)} centered>
            <div
                style={{
                    backgroundColor: '#1c1c1c',
                    color: '#fff',
                    borderRadius: '10px',
                    padding: '1rem',
                    width: '100%',
                }}
            >
                <Modal.Body
                    style={{
                        backgroundColor: '#1c1c1c',
                        color: '#fff',
                        borderRadius: '10px',
                        padding: '1.5rem',
                    }}
                >
                    <div className="text-center">
                        <h1 className="mb-3 fs-20">Success</h1>
                        <p className="mb-4">Review logged successfully.</p>
                        <Button primaryBtn onClick={() => navigate("/withdrawal-requests")}>
                            Go back to withdrawal request list
                        </Button>
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    );




    return (

        <main>
            <TopNav />
            <div className="main-container">
                <SideBar/>
                <SuccessModal />
                <article style={{width: "100%", display: "flex", justifyContent: "center"}}>
                    <section className="user-profile">
                        <div className="user-profile__top flex-wrap gap-1">
                            <div className="user-profile__top-left">
                                <img
                                    src={chevronLeft}
                                    onClick={() => navigate(-1)}
                                    className="user-profile__top-left-icon"
                                    alt="arrow head pointing left"
                                />

                                <h2 style={{color: '#FFFFFF', paddingTop: 10, paddingBottom: 12}}>Request Details</h2>
                            </div>
                        </div>
                        <div className="container_content_user">
                            <div className="content_following">
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Owner Name:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.owner_id?.name || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Owner Email:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.owner_id?.email || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Owner Phone:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.owner_id?.phone || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Requested Amount:</div>
                                    <p style={{color: '#FFFFFF'}}> $ {Number(requestData?.requested_amount) / 100}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Available Funds:</div>
                                    <p style={{color: '#FFFFFF'}}> $ {Number(requestData?.available_funds) / 100}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Status:</div>
                                    <p
                                        style={{
                                            color:
                                                requestData?.status === 'approved'
                                                    ? '#28a745' // green
                                                    : requestData?.status === 'rejected'
                                                        ? '#dc3545' // red
                                                        : requestData?.status === 'pending'
                                                            ? '#ffc107' // yellow
                                                            : requestData?.status === 'processed'
                                                                ? '#17a2b8' // teal/cyan
                                                                : requestData?.status === 'processing'
                                                                    ? '#6f42c1' // purple
                                                                    : '#FFFFFF' // fallback
                                        }}
                                    >
                                        {requestData?.status || 'N/A'}
                                    </p>
                                </div>

                                {requestData?.processed_amount != null && (
                                    <div className="card_following" style={{width: '100%'}}>
                                        <div style={{color: '#FFFFFF'}}>Processed Amount:</div>
                                        <p style={{color: '#FFFFFF'}}>$ {Number(requestData.processed_amount) / 100}</p>
                                    </div>
                                )}

                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Transaction ID:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.transaction_id || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Notes:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.notes || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Requested At:</div>
                                    <p style={{color: '#FFFFFF'}}>{formatDate(requestData?.requested_at) || 'N/A'}</p>
                                </div>

                                {requestData?.status !== 'pending' && requestData?.remark && (
                                    <div className="card_following" style={{width: '100%'}}>
                                        <div style={{color: '#FFFFFF'}}>Remark :</div>
                                        <p style={{color: '#FFFFFF'}}>{requestData?.remark}</p>
                                    </div>
                                )}
                            </div>

                            {/* Account Information Section */}
                            <h2 style={{color: '#FFFFFF', paddingTop: 10, paddingBottom: 12}}>Account Information</h2>
                            <div className="content_following">
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Account Name:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.account_info?.account_name || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Account Number:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.account_info?.account_number || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Bank Name:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.account_info?.bank_name || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>IBAN:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.account_info?.IBAN || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>SWIFT:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.account_info?.SWIFT || 'N/A'}</p>
                                </div>
                                <div className="card_following" style={{width: '100%'}}>
                                    <div style={{color: '#FFFFFF'}}>Routing Number:</div>
                                    <p style={{color: '#FFFFFF'}}>{requestData?.account_info?.routing_number || 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                        <div style={{width: '100%', paddingTop: '20px'}}>
                            {(
                                requestData?.status === 'pending' ||
                                requestData?.status === 'processing'
                            ) && (
                                <>
                                    {/* Text Area for Admin Remark */}
                                    <div style={{width: '100%', paddingBottom: '10px'}}>
                                        <div style={{color: '#FFFFFF', marginBottom: '0.5rem'}}>
                                            Remarks:
                                        </div>
                                        <textarea
                                            className="form-control"
                                            style={{
                                                minHeight: '200px',
                                                resize: 'vertical',
                                                backgroundColor: '#2c2c2c',
                                                color: '#fff',
                                                border: '1px solid #444',
                                            }}
                                            placeholder="Leave a remark here..."
                                            value={adminRemark}
                                            onChange={(e) => setAdminRemark(e.target.value)}
                                        />
                                    </div>

                                    {/* Select for Admin Status */}
                                    <div style={{width: '100%', paddingBottom: '20px'}}>
                                        <div style={{color: '#FFFFFF', marginBottom: '0.5rem'}}>
                                            Review Status:
                                        </div>
                                        <select
                                            className="form-select"
                                            style={{
                                                backgroundColor: '#2c2c2c',
                                                color: '#fff',
                                                border: '1px solid #444',
                                            }}
                                            value={adminStatus}
                                            onChange={(e) => setAdminStatus(e.target.value)}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="rejected">Reject</option>
                                            <option value="processed">Processed</option>
                                            <option value="processing">Processing</option>
                                        </select>
                                    </div>

                                    {/* Submit Button */}
                                    <div style={{width: '100%', textAlign: 'right'}}>
                                        <Button
                                            primaryBtn
                                            onClick={handleReviewSubmit}
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Submitting...' : 'Submit Review'}
                                        </Button>
                                    </div>
                                </>
                            )}
                        </div>


                    </section>

                </article>


            </div>
        </main>
    )
        ;
}

export default WithdrawalRequestDetails;